var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('app-videoContent'),(_vm.initialPreferences.menuItems.length>0)?_c('app-menuContent'):_vm._e(),(_vm.initialPreferences.footerVisible)?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }